import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { ExternalUserStateClass } from "./interfaces/ExternalUserStateClass";
import fetchAPI from "../../../common/fetchAPI";
import { create } from "domain";
import { sortData } from "../../../common/timeLiveFunction";


const initialState: ExternalUserStateClass = {
    isLoading: false,
    status: "idle",
    isReload: false,
    selectedRecord: {},
    externalUserList: [],
    License: true,
    IsEmailAvailable:true,
    sortOrder: 'asc',
    sortColumn: 'FirstName',
    search: '',
    pageNo: 1,
    pageSize: 10
    
}

interface IThunkApi {
    state: {
        externalUser: ExternalUserStateClass
    }
}

export const getExternalUserAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "ExternalUser/v2/getExternalUser",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/ExternalUsers", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )

export const getExternalUserByExternalUserIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ExternalUser/v2/getExternalUserByExternalUserId",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/ExternalUsers/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const addExternalUserAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ExternalUser/addExternalUser",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/ExternalUsers/", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const updateExternalUserAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ExternalUser/v2/updateExternalUser",
        async (arg, thunkApi) => {
            const { AccountEmployeeId, EmployeeTimeZoneId, ConfirmPassword, ...argWithoutId } = arg;
            const response = await fetchAPI("api/v2/ExternalUsers/" + AccountEmployeeId, "PUT", argWithoutId, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const deleteExternalUserAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ExternalUser/v2/deleteExternalUser",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/ExternalUsers/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )
export const ResendVerificationEmailAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Employees/ResendVerificationEmail",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/Employees/ResendVerificationEmail/" + arg, "POST", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )
export const CheckLicenseAsync = createAsyncThunk
    <void, void, IThunkApi>
    (
        "ExternalUsers/v2/CheckLicense",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/ExternalUsers/CheckLicense/", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )
    export const GetEmailAddressValidationAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ExternalUsers/v2/GetEmailAddressValidation",
        async (arg, thunkApi) => {
            const { EMailAddress, AccountEmployeeId} = arg;
            const response = await fetchAPI("api/v2/ExternalUsers/EmailAddressValidation/"+EMailAddress+"/"+AccountEmployeeId, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )
    export const DeleteSelectedExternalUsersAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ExternalUsers/v2/DeleteSelectedExternalUsers",
        async (arg, thunkApi) => {
            // const response = await fetchAPI('api/Expenses/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/v2/ExternalUsers/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

const externalUserSlice = createSlice({
    name: "externalUser",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.externalUserList.findIndex((item) => item.AccountEmployeeId == action.payload);
            const newArray = [...state.externalUserList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.externalUserList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.externalUserList.findIndex((item) => item.AccountEmployeeId == action.payload);
            const newArray = [...state.externalUserList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.externalUserList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.externalUserList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.externalUserList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.externalUserList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.externalUserList = newArray;
            //state.isAllUnChecked = true;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            //state.isAllUnChecked = state.LocationList.every((item) => item.isSelected === 0);
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.externalUserList;
            state.externalUserList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getExternalUserAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getExternalUserAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                //state.externalUserList = payload;
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.externalUserList = [];
                    state.isLoading = false;

                } else {
                    state.externalUserList = payload.Data;
                    state.externalUserList.map((item: any) => {
                        item.isSelected = 0
                    });
                }

                state.isReload = false;
                state.selectedRecord = {};
                state.isLoading = false;
            })
            .addCase(getExternalUserAsync.rejected, (state) => {
                state.status = "failed";
                state.isLoading = false;
            })

            .addCase(getExternalUserByExternalUserIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getExternalUserByExternalUserIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                //state.selectedRecord = payload[0];
                if (Object.keys(payload.Data[0]).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.selectedRecord = {};
                    state.isLoading = false;

                } else {
                    state.selectedRecord = payload.Data[0];
                }
                state.isLoading = false;
            })
            .addCase(getExternalUserByExternalUserIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(addExternalUserAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addExternalUserAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addExternalUserAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(updateExternalUserAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateExternalUserAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateExternalUserAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(deleteExternalUserAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteExternalUserAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteExternalUserAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(ResendVerificationEmailAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(ResendVerificationEmailAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (payload) {
                    state.isReload = true;
                }
                state.isLoading = false;
            })
            .addCase(ResendVerificationEmailAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(CheckLicenseAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(CheckLicenseAsync.fulfilled, (state, action: PayloadAction<boolean | void>) => {
                state.status = 'idle';
                state.License = action.payload !== undefined ? action.payload : true;
                state.isLoading = false;
            })
            .addCase(CheckLicenseAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(GetEmailAddressValidationAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(GetEmailAddressValidationAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.IsEmailAvailable = payload;
               // state.IsEmailAvailable = action.payload !== undefined ? action.payload : true;
                state.isLoading = false;
            })
            .addCase(GetEmailAddressValidationAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(DeleteSelectedExternalUsersAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedExternalUsersAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedExternalUsersAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            

    }
})

export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updateSorting, updatePagination } = externalUserSlice.actions
export const ExternalUserstate = (state: RootState) => state.externalUser
export default externalUserSlice.reducer


